<template>
  <div class="preview-background-root" :style="rootStyle">
    <!-- Show the default background when the web builder is first open -->
    <!-- Set the opacity so the background would fade transition when switched -->
    <div
      :class="{ 'main-preview-background default': true, 'full-body': isFullBodyCategory }"
      :style="{
        opacity: !currentBackgroundId ? backgroundOpacity : '0',
      }"
    />
    <!-- full outfits background -->
    <div
      v-for="brand in selectedBrands()"
      :key="`fashion-background-${brand.id}`"
      :class="{ 'main-preview-background': true, 'full-body': isFullBodyCategory }"
      :style="{
        backgroundImage: `url(${brand.store_background})`,
        opacity:
          brand.id === currentBackgroundId && currentBackgroundType === BackgroundTypeEnum.OUTFIT
            ? backgroundOpacity
            : '0',
      }"
    />
    <!-- mix and match background -->
    <div
      v-for="brand in selectedVoltronBrands()"
      :key="`garment-background-${brand.id}`"
      :class="{ 'main-preview-background': true, 'full-body': isFullBodyCategory }"
      :style="{
        backgroundImage: `url(${brand.store_background})`,
        opacity:
          brand.id === currentBackgroundId &&
          currentBackgroundType === BackgroundTypeEnum.MIX_AND_MATCH
            ? '1'
            : '0',
      }"
    />
  </div>
</template>

<script>
import DetailedOutfitHelper from '@/services/DetailedOutfitHelper';
import { BackgroundTypeEnum } from '@/enum/background';
import { OUTFIT_CATEGORY_KEY } from '@/constants';
import ClientBuild from '@/services/ClientBuild';

const DARK_MODE_BACKGROUND_IMAGE_OPACITY = 0.7;
const LIGHT_MODE_BACKGROUND_IMAGE_OPACITY = 1.0;

export default {
  name: 'PreviewBackground',
  created: function() {
    this.BackgroundTypeEnum = BackgroundTypeEnum;
  },
  computed: {
    rootStyle: function() {
      // Extend the preview background upwards to fill in the top inset
      return {
        top: `-${ClientBuild.getClientInsets().top}px`,
      };
    },
    brands: function() {
      if (this.$store.getters.categories.length > 0) {
        for (const category of this.$store.getters.categories) {
          if (category.key === OUTFIT_CATEGORY_KEY) {
            return category.options;
          }
        }
      }
      return [];
    },
    voltronBrands: function() {
      let result = [];
      if (this.$store.getters.categories.length > 0) {
        for (const category of this.$store.getters.categories) {
          if (DetailedOutfitHelper.DETAILED_OUTFIT_KEYS.includes(category.key)) {
            result = result.concat(category.options);
          }
        }
        return result;
      }
      return [];
    },
    backgroundOpacity: function() {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        // Lower the background image opacity for dark mode.
        return DARK_MODE_BACKGROUND_IMAGE_OPACITY;
      }
      return LIGHT_MODE_BACKGROUND_IMAGE_OPACITY;
    },
    currentBackgroundId: function() {
      return this.$store.getters.backgroundId;
    },
    currentBackgroundType: function() {
      return this.$store.getters.backgroundType;
    },
    selectedBackgroundIds: function() {
      return this.$store.getters.selectedBackgroundIds;
    },
    isFullBodyCategory: function() {
      return this.$store.getters.isFullBodyCategory;
    },
  },
  methods: {
    selectedBrands: function() {
      return this.brands.filter((brand) => this.selectedBackgroundIds.has(brand.id));
    },
    selectedVoltronBrands: function() {
      return this.voltronBrands.filter((brand) => this.selectedBackgroundIds.has(brand.id));
    },
  },
};
</script>

<style scoped>
.preview-background-root {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.main-preview-background {
  overflow: hidden;
  position: absolute;
  width: 100%;
  top: -19%;
  height: 100%;
  background-position: 50% 0%;
  background-size: 157%;
  transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
}

.main-preview-background.default {
  background: url('../../assets/bg-default.4x.jpg') no-repeat;
  /* also need background position and background size here for the transition to work */
  background-position: 50% 0%;
  background-size: 157%;
}

.main-preview-background.full-body {
  /* Set top to -13% to shift the background position to be a little bit lower for full body runway preview */
  top: -13%;
  background-size: 100%;
}

@media (orientation: landscape) {
  .main-preview-background,
  .main-preview-background.full-body {
    top: 0;
    background-position: 50%;
  }
}
</style>
